import React from 'react';
import { Container } from 'semantic-ui-react';

import EpisodeFeed from '../Components/EpisodeFeed';

const Category = ({ episodes, name, filter, loading }) => (
  <Container>
    <EpisodeFeed
      header={name}
      episodes={episodes}
      filter={filter}
      loading={loading}
    />
  </Container>
);

export default Category;
